import React from 'react';
import PropTypes from 'prop-types';

import { ThumbsUp } from 'components/Icons';
import useWorkflowGuard from 'hooks/useWorkflowGuard';

const AllSet = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <ThumbsUp className="mb-6" />
      <p className="text-xl md:text-3xl font-semibold text-slate-800 mb-6">
        You're All Set!
      </p>

      <p className="text-sm md:text-base text-slate-500 px-6 md:px-12">
        Your loan agreement has been signed, your Bitcoin collateral has been secured, and your loan is now being prepared for funding. 
        <br />
        <br />
        Funds are expected to be deposited into your bank account within 1 to 3 business days.
      </p>
    </div>
  );
};

AllSet.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default AllSet;
